import React from 'react';

export default function IcSearch() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Component/icon/ic_Search" stroke="none" fillRule="evenodd">
            <g id="ic_Search">
                <path d="M17.6370981,4.68290188 C20.9070079,7.95281167 21.1879032,13.0798569 18.4797841,16.6688341 L22.0943373,20.2824787 C23.0371463,21.2252878 21.6229328,22.6395013 20.6801237,21.6966923 L17.1082385,18.1265242 C13.5093695,21.2060929 8.08875463,21.0429509 4.68290188,17.6370981 C1.10569937,14.0598956 1.10569937,8.2601044 4.68290188,4.68290188 C8.2601044,1.10569937 14.0598956,1.10569937 17.6370981,4.68290188 Z M6.09711545,6.09711545 C3.30096152,8.89326938 3.30096152,13.4267306 6.09711545,16.2228846 C8.89326938,19.0190385 13.4267306,19.0190385 16.2228846,16.2228846 C19.0190385,13.4267306 19.0190385,8.89326938 16.2228846,6.09711545 C13.4267306,3.30096152 8.89326938,3.30096152 6.09711545,6.09711545 Z" id="Combined-Shape" fill="#000"></path>
            </g>
        </g>
    </svg>
  );
}
